import {
  APPEND_COMPANY_MEMBER_TAG,
  REMOVE_COMPANY_MEMBER_TAG,
  SET_COMPANIES,
  SET_COMPANY_DETAILS,
  SET_COMPANY_MEMBERS,
} from "../actionType";

const setCompaniesData = (data) => {
  return {
    type: SET_COMPANIES,
    payload: data,
  };
};

const setCompanyDetails = (data) => {
  return {
    type: SET_COMPANY_DETAILS,
    payload: data,
  };
};

const setCompanyMembers = (data) => {
  return {
    type: SET_COMPANY_MEMBERS,
    payload: data,
  };
};
const appendMemberTag = (data) => {
  return {
    type: APPEND_COMPANY_MEMBER_TAG,
    payload: data,
  };
};

const removeMemberTag = (data) => {
  return {
    type: REMOVE_COMPANY_MEMBER_TAG,
    payload: data,
  };
};

export {
  appendMemberTag,
  removeMemberTag,
  setCompaniesData,
  setCompanyDetails,
  setCompanyMembers,
};
